@if (!pageTitle && isLoading) {
    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
}
<div class="d-flex flex-column ws-flex-auto min-height-0">
    @if (pageTitle) {
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Company Settings"></ws-bread-crumbs>
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title page-title">{{ pageTitle }}</h4>
                <div class="ws-section__header__actions">
                    @if (!editMode && !editLock && !isLoading) {
                        <div class="ws-section__header__actions__item">
                            <button (click)="setEditMode()" class="ace-btn btn-sm btn-primary has-icon">
                                <i class="fa fa-pencil"></i>
                            </button>
                        </div>
                    }
                    @if (editMode) {
                        <div class="ws-section__header__actions__item">
                            <button (click)="save()" class="ace-btn btn-sm btn-primary has-icon">
                                <i class="fa fa-save"></i>
                            </button>
                        </div>
                    }
                    @if (editMode) {
                        <div class="ws-section__header__actions__item">
                            <button (click)="cancelEdit()" class="ace-btn btn-sm btn-primary has-icon">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="ws-section flex-grow-1 bg-white py-3 px-2 ace-radius position-relative min-height-0">
            @if (isLoading) {
                <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
            } @else {
                <div class="d-flex justify-content-around">
                    <div>
                        @if (!company.parentId) {
                            <div class="setting">
                                <span class="settings-label fw-bold me-2">Company Collectors:</span>
                                <span>
                                    @if (editMode) {
                                        <a [sref]="{ target: 'companyCollectors', options: {companyID: company.companyID} }"
                                           anchor-route>
                                            Manage ({{ company.collectorCount || 0 }})
                                        </a>
                                    }
                                    @if (!editMode) {
                                        <span>{{ company.collectorCount || 0 }}</span>
                                    }
                                </span>
                            </div>
                        }
                        <div class="setting">
                            @if (company.parentId) {
                                <div>
                                    <span class="fw-bold me-2">
                                        Use Top Level Company's Vendor Code Mapping:
                                    </span>
                                    <ws-switch [(ngModel)]="options.useParentVendorFlag"
                                               [disabled]="!editMode"
                                               size="small">
                                    </ws-switch>
                                </div>
                            }
                            @if (!company.useParentVendorCodes || !company.parentId) {
                                <span>
                                    <span class="fw-bold me-2">Company Vendor Code Mapping: </span>
                                    @if (editMode) {
                                        <a [sref]="{ target: 'companyVendorCodes', options: {companyId: companyId} }"
                                           anchor-route>Manage
                                            @if (vendorCodeCountLoading) {
                                                (<i class="fa fa-spinner fa-spin"></i>)
                                            } @else {
                                                ({{ company.vendorCodeCount || 0 }})
                                            }
                                        </a>
                                    }
                                    @if (!editMode) {
                                        <span>
                                            @if (vendorCodeCountLoading) {
                                                <i class="fa fa-spinner fa-spin"></i>
                                            } @else {
                                                {{ company.vendorCodeCount || 0 }}
                                            }
                                        </span>
                                    }
                                </span>
                            }
                        </div>
                        <div class="setting">
                            <span class="d-inline-block fw-bold me-2">Fiscal Year Start:</span>
                            <input [(ngModel)]="options.fiscalYearStart"
                                   [disabled]="!editMode"
                                   class="form-control sd-validate-input-text d-inline-block"
                                   name="fiscalYearStartInput"
                                   pattern="(0?[1-9]|1[012])/(0?[1-9]|[12]\d|3[01])"
                                   required
                                   style="width:60px;"
                                   title="Value format is MM/DD"
                                   type="text"/>
                        </div>
                        @if (isTopLevelCompany && !dxpSyncDisabled && entityIsInRyanInstance) {
                            <div class="setting">
                                <span class="fw-bold me-2">
                                    Sync with Tax Access:
                                </span>
                                <ws-switch [(ngModel)]="options.syncDXPFlag"
                                           [disabled]="!editMode || syncDxpLocked"
                                           size="small">
                                </ws-switch>
                            </div>
                        }
                        @if (showInvoiceAppealSavingsSetting) {
                            <div class="setting">
                                <div>
                                    <span [ngClass]="{'red': invoiceAppealSavingsOverridden()}"
                                          class="fw-bold me-2 pe-1">
                                        Invoice Appeal Savings:
                                    </span>
                                    <ws-switch [(ngModel)]="options.invoiceAppealSavingsFlag"
                                               [disabled]="!this.editMode || !this.entityIsInRyanInstance">
                                    </ws-switch>
                                </div>
                                <div>
                                    <span [ngClass]="{'red': requireClientApprovalOverridden()}"
                                          class="fw-bold me-2">
                                        Client Appeal Recommendation:
                                    </span>
                                    <ws-switch [(ngModel)]="options.requireClientApprovalFlag"
                                               [disabled]="!this.editMode || !this.entityIsInRyanInstance">
                                    </ws-switch>
                                </div>
                            </div>
                        }
                        @if (isTopLevelCompany) {
                            <div class="setting">
                                <div>
                                    <span class="fw-bold me-2">Budgets Enabled:</span>
                                    <ws-switch (selectedOptionChanged)="budgetEnabledChanged($event)"
                                               [(ngModel)]="options.budgetsEnabled"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                                @if (options.budgetsEnabled) {
                                    <div class="mt-2">
                                        <label class="me-1">Basis:</label>
                                        <ws-select [(ngModel)]="options.budgetBasis"
                                                   [disabled]="!editMode"
                                                   [options]="budgetBasisOptions"
                                                   labelProperty="name">
                                        </ws-select>
                                        <div class="mt-2">
                                            @if (flatInUseDescriptors) {
                                                <budget-descriptors-link
                                                    [companyId]="company.companyID"
                                                    [editMode]="editMode"
                                                    [flatInUseDescriptors]="flatInUseDescriptors"
                                                    [options]="options">
                                                </budget-descriptors-link>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (isTopLevelCompany && accrualsEnabled) {
                            <div class="setting">
                                <div>
                                    <span class="fw-bold me-2">
                                        Accruals Enabled:
                                    </span>
                                    <ws-switch (selectedOptionChanged)="accrualsEnabledChanged($event)"
                                               [(ngModel)]="options.accrualsEnabled"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                                @if (options.accrualsEnabled) {
                                    <div>
                                        <div class="mt-2">
                                            <accounting-periods-link [companyId]="company.companyID"
                                                                     [editMode]="editMode">
                                            </accounting-periods-link>
                                        </div>
                                        <div class="mt-2">
                                            @if (flatInUseDescriptors) {
                                                <accruals-descriptors-link [companyId]="company.companyID"
                                                                           [editMode]="editMode"
                                                                           [flatInUseDescriptors]="flatInUseDescriptors"
                                                                           [options]="options">
                                                </accruals-descriptors-link>
                                            }
                                        </div>
                                        <div class="mt-2">
                                            <accrual-paid-date-precedences-link [companyId]="company.companyID"
                                                                                [editMode]="editMode"
                                                                                [options]="options">
                                            </accrual-paid-date-precedences-link>
                                        </div>
                                        <div class="mt-2">
                                            <label class="me-1">Tax Amount Adjustments:</label>
                                            <ws-select [(ngModel)]="options.defaultAccrualAdjustmentMethodId"
                                                       [disabled]="!editMode"
                                                       [options]="taxAmountAdjustments"
                                                       labelProperty="name">
                                            </ws-select>
                                        </div>
                                        <div class="mt-2">
                                            <label class="me-1">Economic Unit:</label>
                                            <ws-select [(ngModel)]="options.accrualEconUnitTypeId"
                                                       [disabled]="!editMode"
                                                       [options]="economicUnitTypes"
                                                       labelProperty="name"
                                                       valueProperty="economicUnitTypeId">
                                            </ws-select>
                                        </div>
                                        @if (options.accrualEconUnitTypeId === 3) {
                                            <div class="mt-2">
                                                <label class="me-1">Economic Unit Site Code:</label>
                                                <descriptor-picker (selected)="descriptorSelected($event)"
                                                                   [companyId]="company.companyID"
                                                                   [descriptorId]="options.accrualEconUnitDescriptorId"
                                                                   [disabled]="!editMode"
                                                                   [entityTypeId]="5"
                                                                   class="d-inline-block w-auto">
                                                </descriptor-picker>
                                            </div>
                                        }
                                        <div class="mt-2">
                                            <label class="me-1">Export File Type:</label>
                                            <ws-select [(ngModel)]="options.accrualFileTypeId"
                                                       [disabled]="!editMode"
                                                       [options]="exportFileTypes"
                                                       labelProperty="name"
                                                       valueProperty="accrualFileTypeId">
                                            </ws-select>
                                        </div>
                                        <div class="mt-2">
                                            <label class="me-1">Export Property Identifier:</label>
                                            <ws-select (ngModelChange)="exportPropertyChanged($event)"
                                                       [disabled]="!editMode"
                                                       [ngModel]="options.accrualExportPropertyIdentificationId"
                                                       [options]="exportProperties"
                                                       labelProperty="name">
                                            </ws-select>
                                            <div class="mt-2">
                                                @if (!siteNumberSelectedForExport) {
                                                    <accruals-descriptor-selector [(selectedDescriptorId)]="options.accrualExportPropIdentDescriptorId"
                                                                                  [disabled]="!editMode"
                                                                                  [inUseDescriptors]="siteCharSelectedForExport ? inUseDescriptors.SITE : inUseDescriptors.PARCEL"
                                                                                  placeholder="Choose Descriptor">
                                                    </accruals-descriptor-selector>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (!isTopLevelCompany && accrualsEnabled && options.tlCompanyAccrualsEnabled) {
                            <div class="setting">
                                <div>
                                    <span  class="fw-bold me-2">
                                        Exclude Company From Accruals:
                                    </span>
                                    <ws-switch [(ngModel)]="options.excludeFromAccruals"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                            </div>
                        }
                        <div class="setting">
                            <div>
                                <a [sref]="{ target: 'glAccountList', options: { companyId: ((options.useTopLevelCompanyCOA) ? company.topLevelCompanyId : company.companyID)}}"
                                   anchor-route>
                                    Chart of Accounts @if (options.useTopLevelCompanyCOA) {
                                    <span>({{ parentCompany.companyName }} and its subsidiary companies)</span>
                                }
                                </a>
                            </div>
                            @if (!isTopLevelCompany) {
                                <div class="mt-2">
                                    <span  class="fw-bold me-2">
                                        Use Top-Level Company Chart of Accounts:
                                    </span>
                                    <ws-switch [(ngModel)]="options.useTopLevelCompanyCOA"
                                               [disabled]="!editMode || !canChangeUseTopLevelCompanyCOA"
                                               [title]="useTopLevelCompanyCOATitle">
                                    </ws-switch>
                                </div>
                            }
                        </div>
                        @if (hasManageConsultingEngagements && isTopLevelCompany) {
                            <div class="setting">
                                <span><strong>Consultants: </strong></span> @if (editMode) {
                                <a (click)="showContracts()" class="pointer">Manage</a>
                            }
                            </div>
                        }
                        @if (company.hasIncomeStatements && isTopLevelCompany) {
                            <div class="setting">
                                <a [sref]="{ target: 'companyIncomeStatement', options: { companyId: company.companyID}}"
                                   anchor-route>
                                    Income Statements
                                </a>
                            </div>
                        }
                        @if (company.hasRentRolls && isTopLevelCompany) {
                            <div class="setting">
                                <a [sref]="{ target: 'companyRentRoll', options: { companyId: company.companyID}}"
                                   anchor-route>
                                    Rent Rolls
                                </a>
                            </div>
                        }
                    </div>
                    <div>
                        <div class="card panel-flat-color secondary-panel small-panel mb-0"
                             style="overflow: initial;">
                            <div class="panel-flat-header small-header">
                                <h3>Utilities</h3>
                            </div>
                            <div class="card-body">
                                <div class="setting">
                                    <div class="ws-flex-container-horizontal ws-flex-align-items-center spacing-bottom">
                                        <label class="utilities-form-label">Year</label>
                                        <ws-select [(ngModel)]="yearToAdd"
                                                   [disabled]="!editMode"
                                                   [isPrimitive]="true"
                                                   [options]="yearsToAdd"
                                                   class="ws-stretch-width">
                                        </ws-select>
                                        @if (editMode) {
                                            <button
                                                (click)="startAddYear()"
                                                [disabled]="addingYear || (selectingState && !companyStateModel.stateNames.length)"
                                                class="ace-btn has-icon btn-primary btn-sm spacing-margin"
                                                helpTooltip
                                                tooltipText="Add Year">
                                                <i class="fa fa-plus"></i>
                                            </button>
                                        }
                                    </div>
                                    @if (editMode && addingYear) {
                                        <div class="ws-flex-container-vertical">
                                            @if (companyStates && companyStates.length) {
                                                <div class="ws-flex-container-horizontal ws-flex-align-items-center ws-stretch-width spacing-bottom">
                                                    <label class="utilities-form-label">Select States</label>
                                                    <span [class.disabled]="!editMode" class="checkbox-container">
                                                        <input [checked]="selectingState"
                                                               [disabled]="!editMode"
                                                               type="checkbox">
                                                        <span (click)="toggleSelectingState()"
                                                              class="checkbox-checkmark"></span>
                                                    </span>
                                                    <div class="ws-flex-grow spacing-margin">
                                                        <ws-multi-select [(ngModel)]="companyStateModel.stateNames"
                                                                         [disabled]="!(selectingState && editMode)"
                                                                         [isPrimitive]="true"
                                                                         [options]="companyStates"
                                                                         class="ws-stretch-width">
                                                        </ws-multi-select>
                                                    </div>
                                                </div>
                                            }
                                            <div class="ws-flex-container-horizontal ws-flex-justify-content-flex-end">
                                                @if (editMode) {
                                                    <button
                                                        (click)="cancelAddYear()"
                                                        class="ace-btn btn-primary btn-danger btn-sm"
                                                        helpTooltip
                                                        tooltipText="Cancel">
                                                        Cancel
                                                    </button>
                                                }
                                                @if (editMode) {
                                                    <button
                                                        (click)="addYear(yearToAdd)"
                                                        [disabled]="selectingState && !companyStateModel.stateNames.length"
                                                        class="ace-btn btn-primary btn-sm"
                                                        helpTooltip
                                                        tooltipText="Add Year">
                                                        Add Year
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (isTopLevelCompany && canImportData) {
                                    <div class="setting">
                                        <a [sref]="{ target: 'companyImports', options: {companyId: company.companyID} }"
                                           anchor-route>
                                            Data Imports
                                        </a>
                                    </div>
                                }
                            </div>
                        </div>
                        @if (showAllocations) {
                            <div class="card panel-flat-color secondary-panel small-panel mt-2">
                                <div class="panel-flat-header small-header">
                                    <h3>Allocations</h3>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <span [ngClass]=" {'red': enableAllocationsOverridden()}"
                                               class="fw-bold me-2">
                                            Allocations:
                                        </span>
                                        <ws-switch [(ngModel)]="options.enableAllocations"
                                                   [disabled]="!this.editMode">
                                        </ws-switch>
                                    </div>
                                    <div>
                                        <a [sref]="{ target: 'responsibleEntityList', options: {companyId: company.topLevelCompanyId} }"
                                           anchor-route>Responsible Entities @if (!isTopLevelCompany) {
                                            <span>({{parentCompany?.companyName}} and its subsidiary companies)</span>
                                        }
                                        </a>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (entityIsInRyanInstance) {
                            <div class="card panel-flat-color secondary-panel small-panel mt-2">
                                <div class="panel-flat-header small-header">
                                    <h3>Payment Batch Settings</h3>
                                </div>
                                <div class="card-body">
                                    <div class="mt-2">
                                        @if (flatInUseDescriptors) {
                                            <payment-batch-descriptors-link
                                                [companyId]="company.companyID"
                                                [editMode]="editMode"
                                                [flatInUseDescriptors]="flatInUseDescriptors"
                                                [options]="options">
                                            </payment-batch-descriptors-link>
                                        }
                                    </div>
                                    @if (enablePaymentBatchDataHub) {
                                        <div class="setting">
                                            <div>
                                                <span  class="fw-bold me-2">
                                                    Data Hub Enabled:
                                                </span>
                                                @if (isTopLevelCompany) {
                                                    <ws-switch
                                                        [(ngModel)]="options.dataHubEnabled"
                                                        [disabled]="!editMode">
                                                    </ws-switch>
                                                }
                                                @if (!isTopLevelCompany) {
                                                    <span>{{ options.dataHubEnabled ? 'Yes' : 'No' }}</span>
                                                }
                                            </div>
                                            @if (options.dataHubEnabled) {
                                                <div>
                                                    <span class="me-2 mt-3 fw-bold d-inline-block">
                                                        Data Hub Client Tenant Id:
                                                    </span>
                                                    @if (isTopLevelCompany && editMode) {
                                                        <input [(ngModel)]="options.dataHubClientTenantId"
                                                            required
                                                            maxlength="50"
                                                            class="d-inline-block"
                                                            style="width: 300px;"
                                                            type="text">
                                                    }
                                                    @if (!isTopLevelCompany || !editMode) {
                                                        <span>{{ options.dataHubClientTenantId }}</span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (enableLitigationReferrals) {
                                <div class="setting">
                                    <div>
                                        <span class="fw-bold me-2">Allow Litigation Referrals:</span>
                                        @if (isTopLevelCompany) {
                                            <ws-switch
                                                [(ngModel)]="options.litigationReferralsEnabled"
                                                [disabled]="!editMode">
                                            </ws-switch>
                                        }
                                        @if (!isTopLevelCompany) {
                                            <span>{{ options.litigationReferralsEnabled ? 'Yes' : 'No' }}</span>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
